const appRoutePath = {
  // auth paths
  AUTH_PAGE: "/auth",
  AUTH_ACCOUNT_VERIFICATION_PAGE: "verify-account",
  AUTH_SIGNUP_PAGE: "signup",
  AUTH_CREATE_PASSWORD_PAGE: "create-password",
  AUTH_FORGOT_PASSWORD_PAGE: "forgot-password",
  AUTH_RESET_PASSWORD_PAGE: "reset-password",
  AUTH_LOGOUT_PAGE: "logout",

  // USER MANAGEMENT
  USERS_PAGE: "users",
  ADD_USERS_PAGE: "/users/add",
  EDIT_USERS_PAGE: "/users/:id/edit",
  USERS_ROLES_PAGE: "roles",
  USER_CHANGE_PASSWORD_PAGE: "user/change-password",

  // dashboard path
  APP_HOME_PAGE: "/",

  // ASSET REGISTRY
  ASSET_REGISTRY_HISTORY_PAGE: "/assets",
  ADD_ASSET_REGISTRY_PAGE: "/assets/add",
  EDIT_ASSET_REGISTRY_PAGE: "/assets/edit/:id",
  ASSET_REGISTRY_DETAIL_PAGE: "/asset/detail/:id",

  // ASSET DISTRIBUTIONS
  ASSET_DISTRIBUTION_DETAIL_PAGE: "/asset-distribution/detail/:id",
  ADD_ASSET_DISTRIBUTION_PAGE: "/asset-distribution/add",

  INBOUND_ASSET_DISTRIBUTIONS_PAGE: "/asset-distribution/incoming",
  INBOUND_ASSET_DISTRIBUTIONS_DETAILS_PAGE:
    "/asset-distribution/incoming/detail/:id",
  INBOUND_ASSET_DISTRIBUTIONS_ACTION_PAGE:
    "/asset-distribution/incoming/:id/action",

  OUTBOUND_ASSET_DISTRIBUTIONS_PAGE: "/asset-distribution/outgoing",
  OUTBOUND_ASSET_DISTRIBUTIONS_DETAIL_PAGE:
    "/asset-distribution/outgoing/detail/:id",
  OUTBOUND_ASSET_DISTRIBUTIONS_EDIT_PAGE:
    "/asset-distribution/outgoing/edit/:id",

  REJECTED_INBOUND_ASSET_DISTRIBUTIONS_PAGE: "/asset-distribution/rejections",
  REJECTED_INBOUND_ASSET_DISTRIBUTIONS_DETAIL_PAGE:
    "/asset-distribution/rejections/:id/details",

  // ASSET DISPATCH
  ADD_ASSET_DISPATCH_PAGE: "/asset-dispatch/add",
  ASSET_DISPATCH_HISTORY_PAGE: "/asset-dispatch/history",
  ASSET_DISPATCH_DETAIL_PAGE: "/asset-dispatch/detail/:id",
  UPDATE_ASSET_DISPATCH_PAGE: "/asset-dispatch/update/:id",

  // ASSET ASSIGNMENT
  ASSET_IN_MY_POSSESSION_PAGE: "/asset-assignments/in-my-possession",
  ASSET_DISTRIBUTION_READY_FOR_ASSIGNMENT_PAGE:
    "/asset-assignment/distributions",
  ADD_NEW_ASSET_ASSIGNMENT_PAGE:
    "/asset-assignment/distributions/:id/assign-asset",

  INBOUND_ASSET_ASSIGNMENT_PAGE: "/asset-assignment/incoming",
  REJECTED_INBOUND_ASSET_ASSIGNEMENT_PAGE: "/asset-assignment/rejections",
  REJECTED_INBOUND_ASSET_ASSIGNEMENT_DETAILS_PAGE:
    "/asset-assignment/rejections/:id/details",
  INBOUND_ASSET_ASSIGNMENT_ACTION_PAGE: "/asset-assignment/incoming/:id/action",

  OUTBOUND_ASSET_ASSIGNMENT_PAGE: "/asset-assignment/outgoing",
  OUTBOUND_ASSET_ASSIGNMENT_EDIT_PAGE: "/asset-assignment/outgoing/edit/:id",

  ASSET_ASSIGNMENT_DETAIL_PAGE: "/asset-assignment/detail/:id",

  // ASSET REPORT
  ASSET_REPORT_FORM: "/asset-report/form",
  ASSET_REPORT_HISTORY: "/asset-report/history",
  EDIT_ASSET_REPORT_FORM: "/asset-reports/edit/:id",
  ASSET_REPORT_DETAIL_PAGE: "/asset-report/detail/:id",

  // MAINTENANCE SCHEDULE
  ASSET_MAINTENANCE_HISTORY_PAGE: "/asset-maintenance/history",
  ADD_ASSET_MAINTENANCE_PAGE: "/asset-maintenance/add",
  EDIT_ASSET_MAINTENANCE_PAGE: "/asset-maintenance/edit/:id",
  ASSET_MAINTENANCE_DETAIL_PAGE: "/asset-maintenance/detail/:id",

  // SETTINGS MANAGEMENT PATHS
  MANAGE_DIVISIONS_PAGE: "/manage-divisions",
  MANAGE_PROGRAMMES_PAGE: "/manage-programmes",
  MANAGE_FACILITIES_PAGE: "/manage-facilities",
  MANAGE_REGIONS_PAGE: "/manage-regions",
  MANAGE_DISTRICTS_PAGE: "/manage-districts",
  MANAGE_DONORS_PAGE: "/manage-donors",
  MANAGE_BATCHES_PAGE: "/manage-batches",

  // ASSET_CATEGORIES
  MANAGE_ASSET_CATEGORIES_PAGE: "/manage-asset-categories",
  MANAGE_ASSET_TAGS_PAGE: "/manage-asset-tags",

  // USER_CATEGORIES
  MANAGE_USER_CATEGORIES_PAGE: "/manage-user-categories",

  // DASHBOARD
  DASHBOARD_HOME_PAGE: "/",
  // UnauthorizedAccessPage
  UnAUTHORIZED_ACCESS_PAGE: "/unauthorized-access",
} as const;
export type AppRoutePathTy = (typeof appRoutePath)[keyof typeof appRoutePath];
export default appRoutePath;
